import React, { useState } from "react"
import Layout from "../../../components/layouts"
import Banner from "../../../components/features/Banner"
import SEO from "../../../components/common/SEO"
import ReactWOW from "react-wow"
import FeatureCards from "../../../components/features/FeatureCards"

export const query = graphql`
  query Polls {
    site {
      siteMetadata {
        defaultTitle: title
        titleTemplate
        defaultDescription: description
        siteUrl: url
        defaultImage: image
        twitterUsername
      }
    }
  }
`

export default ({ data }) => {
  const [toggler, setToggler] = useState(false)
  const lightboxProps = {
    toggler: toggler,
    setToggler: setToggler,
    sources: ["https://www.youtube.com/watch?v=xE2yXvWB038"],
  }

  const bannerProps = {
    title: "Polls",
    subtitle: `Looking for an easy way to figure out where your workers want to go for the company Christmas party? Or maybe you need opinions on a new logo? Our Polls feature allows you to collect feedback on whatever topic you choose while driving engagement and providing your employees with a sense of ownership of decisions made within your organization.`,
    featureName: "polls",
    rightButtonText: "Why Certificate Tracking Software?",
    rightButtonSrc: "https://www.youtube.com/watch?v=xE2yXvWB038",
    mockupImg: '/features/polls/polls-header.png'
  }

  const seo = {
    title: "Workhub | Free Polling Software for Workplace Voting Employees",
    description: "Engage employees & get company feedback by allowing your workers to vote on internal affairs like event scheduling, policies, lunch options & employee satisfaction with our secure Polls tool.",
    image: "/features/polls/social-card.jpg",
    // pathname,
    // article
  }

  const featureIndex = [
    {
      title: "Gain Insights",
      para: "Poll your workforce on company issues like, “What make should the new fleet vehicles be?” or more light-hearted topics such as, “Where should the company Christmas party be?”",
    },
    {
      title: "Elevate Compliance",
      para: "Workers will want to weigh in on the more fun, extracurricular themed polls. Setting a minimum compliance level will encourage your workers to get up to date so they can participate.",
    },
    {
      title: "Share Results",
      para: "Choose to automatically send out results in a Bulletin when a poll ends or generate a bulletin draft on demand for completed polls. This includes a summary and graph of results.",
    },
    {
      title: "Track Responses and Participation",
      para: "Refer to the participation chart to review overall interaction with the poll. View and filter individual responses by position and location in the Worker Responses tab.",
    },
   
  ]


  return (
    <Layout {...lightboxProps}>
      <SEO {...seo} {...data.site} />
      <Banner {...bannerProps} {...lightboxProps} />

      <main className="feature-main">
        <section className="feature-section">
          <div className="container">
            <div className="row switch-children">
              <div className="col-lg-6 feature-img">
                <ReactWOW animation="fadeInLeft" delay="0.9s">
                  <img
                    className="feature-img-right"
                    src="/features/polls/sketch-mockup-spolls-admin-1.png"
                    alt="Admin Computer"
                  />
                </ReactWOW>
              </div>

              <div className="col-lg-6 feature-text">
                <h2>
                What do you think?
                </h2>
                <p>
                  Polls is one of our most fun components. You can use it to get feedback on what everyone wants for lunch on Friday, or to ask more serious questions like, “What make should our new fleet vehicles be?” However, it can also be a sneakily incentivizing tool for driving up compliance and ensuring workers complete their required tasks.
                </p>
                <p>
                  Let’s say that Bob has very strong opinions on whether pineapple belongs on pizza - but Bob only has a 40% compliance score. You set up your pizza lunch choice poll to require 90% compliance for workers to participate. Suddenly, Bob-who-vehemently-opposes-pineapple-on-pizza is 100% compliant, has voted in the poll, and has also managed to sway the vote to Meat Lovers by lunch on Friday.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="feature-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 feature-text">
                <h2>Opinions count!</h2>

                <p>
                  To create a poll, simply add a question for your workers to answer, provide answer choices, and select recipients within your account. The poll can be set to release immediately or at a future date. Specify whether the poll accepts single or multiple selections. A question with multiple answers might be something like, “Which dates would you be available for the summer barbeque?”
                </p>
              </div>

              <div className="col-lg-6 feature-img">
                <ReactWOW animation="fadeInRight" delay="0.9s">
                  <img
                    className="feature-img-left"
                    src="/features/polls/sketch-mockup-spolls-worker-1.png"
                    alt="Worker Mobile"
                  />
                </ReactWOW>
              </div>
            </div>
          </div>
        </section>

        {/* VIDEO CONTAINER */}

        <section className="feature-section video-section">
          <div>
            <div className="row video-row switch-children">

            <ReactWOW animation="fadeInLeft" delay="0.9s">
              <div className="video-bg-size" style={{width: '45%'}}>

              <div className="iframe-contain">
                <iframe width="700" height="500" src="https://www.youtube.com/embed/DvVwfatjueQ" title="Workhub Webinar : Surveys. Suggestions &amp; Polls" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
              </div>
              </div>
              
              </ReactWOW>

              <div className="feature-text video-text" style={{width: '35%'}}>
                <h2>
                  Organize your (workers') thoughts
                </h2>

                <p>
                  If you have several polls going at the same time, you can organize them by setting a priority level. You can also allow people to vote anonymously. An example could be when you want to gauge your workers' satisfaction with a Mental Health and Wellness program, or how they perceived the success of a new product roll-out.
                </p>
                <p>
                  Open any poll from your admin dash to view participation rates and total votes, or hop over to the Worker Responses tab to view the details.
                </p>
              </div>
            </div>
          </div>
        </section>


        <section className="feature-overview-container">
          <h2>Overview</h2>

          <div className="feature-overview-grid">
            {featureIndex.map(item => (
              <FeatureCards title={item.title} para={item.para} />
            ))}
          </div>
        </section>
      

      </main>
    </Layout>
  )
}
